const BB_DETAILS = {
  name: "BankingBridge",
  streetAddress: "412 Country Club Blvd",
  city: "Summerville",
  state: "SC",
  zipcode: "29483",
  phone: "(843) 514-3325",
  email: "support@bankingbridge.com"
}

export default BB_DETAILS
